<template>
  <div class="press">
    <div class="campus">电商管理
      <span>></span>
    标签管理
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="header">全部标签</div>
          <el-button type="primary" class="mb-24" @click="addLabel">
            新建标签
          </el-button>
          <div class="search">
            <span>标签名称：</span>
            <el-input v-model="searchName" @keyup.13.native="getCommerceList" placeholder="请输入标签名称"></el-input>
            <el-button type="primary" class="buttons" @click="getCommerceList">查 询</el-button>
          </div>

          <div class="tableStyle">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column label="标签名称" prop="name" align="center">
              </el-table-column>
              <el-table-column label="标签样式" prop="color" align="center">
                <template slot-scope="scope">
                  <div class="ectag_style" :style="{'background':scope.row.backgroundColor,'color':scope.row.fontColor}">{{scope.row.name}}</div>
                </template>
              </el-table-column>
              <el-table-column label="标签类型" prop="typeStr" align="center">
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="editPress(scope.row)">编辑</el-button>
                  <el-button type="text" @click="deletPress(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="dz-flex dz-flex-justify-end mt-12">
            <el-pagination background @size-change="getCommerceList" @current-change="getCommerceList" :current-page.sync="page" :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
      </el-card>
    </div>
    <!-- 会话框 -->
    <div class="dialogStyle">
      <!-- 新建,编辑标签 -->
      <el-dialog :title="dialogType ? '编辑标签':'新增标签'" :visible.sync="publicDialog" width="600px" center :before-close="cancel">
        <el-form ref="forms" :model="forms"  :rules="FormRules" label-width="120px">
          <el-form-item label="标签名称:" prop="name">
            <el-input v-model="forms.name" placeholder="请输入标签名称"></el-input>
          </el-form-item>
          <el-form-item label="标签类型:" prop="abbreviation">
            <el-select v-model="forms.abbreviation" @change="onSelectedDrug($event)">
              <el-option v-for="(item) in typeList" :key="item.id" :label="item.value" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签颜色:" prop="labelColor">
            <el-color-picker v-model="forms.labelColor"></el-color-picker>
          </el-form-item>
          <el-form-item label="字体颜色:" prop="fontColor">
            <el-color-picker v-model="forms.fontColor"></el-color-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel()">取 消</el-button>
          <el-button type="primary" @click="submitAdd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { $debounce } from '@/utils/index';
const FormRules = {
  name: [
    {
      required: true,
      message: '请输入标签名称',
      trigger: ['blur', 'change'],
    },
  ],
  labelColor: [
    {
      required: true,
      message: '请输入颜色',
      trigger: ['change'],
    },
  ],
  fontColor: [
    {
      required: true,
      message: '请输入字体颜色',
      trigger: ['change'],
    },
  ],
  abbreviation: [
    {
      required: true,
      message: '请选择类型',
      trigger: ['blur', 'change'],
    },
  ],
};
export default {
  data() {
    return {
      FormRules,
      searchName: '',
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      publicDialog: false,
      publicDialog1:false,
      dialogType: '',
      typeLabelValue:'',
      editId:'',
      forms: {
        name: '',
        abbreviation:'',
        labelColor:'',
        fontColor:'',
      },
      
      typeList:[
        {
          value:'综合课程标签',
          id:1,
        },
        {
          value:'专项课程标签',
          id:2,
        },
        {
          value:'通用',
          id:3,
        },
      ],
    };
  },
  created() {
    this.$nextTick(() => {
      // 调用 查询出版社列表
      this.getCommerceList();
    });
  },
  methods: {
    // 查询电商列表
    getCommerceList() {
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/label',
        params:{
          name:this.searchName,
          page: this.page,
          pageSize: this.pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.tableData = result.data.data;
            this.total = result.data.size;
          } 
        })
        .catch((err) => {
          this.$message.error('查询失败'+err)
        });
    },
    // 新增标签
    addLabel(){
      this.dialogType = 0;
      this.publicDialog = true;
    },
    //编辑标签
    editPress(row){
      this.forms.labelColor =row.backgroundColor;
      this.forms.fontColor = row.fontColor
      this.forms.name = row.name;
      this.forms.abbreviation = row.typeStr;
      this.dialogType = 1;
      this.editId = row.id;
      this.publicDialog = true;
    },


    // 确认新增和编辑标签  新增dialogType:0 编辑dialogType:1
    submitAdd: $debounce(function () {
      this.$refs['forms'].validate(async (valid) => {
        //   // 如果表单验证失败，停止请求提交
          if (this.dialogType) {
            let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/label/'+this.editId+'/upd',
        method: 'POST',
        data:{
          backgroundColor:this.forms.labelColor,
          fontColor:this.forms.fontColor,
          name:this.forms.name,
          type:this.typeLabelValue,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.getCommerceList();
            this.$message.success('编辑成功！');
            this.forms.labelColor = '';
            this.forms.fontColor = '';
            this.forms.name = '';
            this.forms.abbreviation = '';
            this.publicDialog = false;
            this.dialogType = 0;
          }
          else {
            this.$message.error('编辑失败：' + res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error('编辑失败：' + err);
        });
          } else {
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/label',
        method: 'POST',
        data:{
          backgroundColor:this.forms.labelColor,
          fontColor:this.forms.fontColor,
          name:this.forms.name,
          type:this.typeLabelValue,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.getCommerceList();
            this.$message.success('添加成功！');
            this.forms.labelColor = '';
            this.forms.fontColor = '';
            this.forms.name = '';
            this.forms.abbreviation = '';
            this.publicDialog = false;
            this.dialogType = 0;
          } else {
            this.$message.error('新建失败：' + res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error('新增失败：' + err);
        });
          }
      });
    }, 500),
    cancel(){
            this.publicDialog = false;
            this.forms.labelColor = '';
            this.forms.fontColor = '';
            this.forms.name = '';
            this.forms.abbreviation = '';
    },
     //删除标签
     deletPress(row){
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let confirmText = [
          '确认要删除吗?',
          '(删除标签会删除该标签与课程的关联)'
        ]
        const newDatas = []
        const h = this.$createElement
        for (const i in confirmText) {
          newDatas.push(h('p', null, confirmText[i]))
        }
      this.$confirm('确认要删除吗?',  {
        title:'删除',
        message: h('div', null, newDatas),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
         let pro = this.$http({
        url: '/edu/mall/course/label/'+row.id+'/del',
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.getCommerceList();
            this.$message.success('删除成功！');
          } 
        })
        .catch((err) => {
          this.$message.error('删除失败：' + err);
        });
      })
      .catch((err)=>{
      })
     
     },
   onSelectedDrug(e){
     this.typeLabelValue = e;
    },
  },
};
</script>

<style lang="less" scoped>
.label_color {
  width: 100px;
  height: 30px;
  border: 1px solid;
  margin-left: 140px;
}
.ectag_style {
  width: 200px;
  height: 100%;
  text-align: center;
  margin-left: 100px;
}
.press {
  .el-button--text:active {
    color: #00a6e6;
  }
  .el-button--text {
    color: #00a6e6;
  }
  .avatar-uploader {
    img {
      width: 120px;
      height: 120px;
    }
  }
  /deep/.el-upload {
    text-align: left;
  }
  .tableImg {
    width: 80px;
    height: 80px;
  }
  /deep/.el-card__body {
    padding: 0 1.3vw;
  }
}
</style>
